<template>
  <!-- <input :id="id" :value="value" @input="$emit('input', $event.target.value)"
    class="search-input"> -->
    <input :id="id" :value="value" @input="onChange($event)"
    class="search-input">
</template>

<script>
export default {
  props: {
    id: String,
    value: String,
  },
  methods: {
    onChange(event){
      // console.log("변경 => ", event.target.value);
      this.$emit('input', event.target.value);
    }
  }
};
</script>

<style scoped>
.search-input {
  width: 100%;
  height: 36px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 14px;
  background: #fff;
}

input:focus {
  outline: none;
  border: 1px solid #999;
}
</style>